__turbopack_context__.v({
  "dot": "swatch-module-scss-module__rax7Ca__dot",
  "root": "swatch-module-scss-module__rax7Ca__root",
});
